<template>
<div>
  <Navigator />
  <Index/>
  <Footer/>

</div>
</template>

<script>
// @ is an alias to /src
import Navigator from '@/components/Navigator'
import Footer from '@/components/Footer'
import Index from '@/components/Index'

export default {
  name: 'home',
  components: {
    Navigator, 
    Index,
    Footer
  },
  metaInfo: {
    title: "Go4Pro.org | 编程、编程、编程",
    htmlAttrs: {
      lang: 'zh-CN'
    },
    meta: [
      {name: 'description', content: "一个专注于搜罗编程技术文章的站点"},
      {name: 'keyword', content: "programming, article, feed"}
    ]
  }  

}
</script>
